import { Button, type ButtonVariant } from '@heidi/design-system/button';
import { Loader2 } from 'lucide-react';
import { type ReactNode } from 'react';

export type PricingPlanCardCtaVariant = Extract<
  ButtonVariant,
  'secondary' | 'pro' | 'pro_plus' | 'outline' | 'default'
>;

export type PricingPlanCardCtaButtonProps = {
  variant: PricingPlanCardCtaVariant;
  /** Leading tier glyph, chosen by the card that knows its plan. */
  icon?: ReactNode;
  onClick: () => void;
  isCtaLoading?: boolean;
  isCtaDisabled?: boolean;
  ctaText: ReactNode;
  'data-testid'?: string;
};

export function PricingPlanCardCtaButton({
  variant,
  icon,
  onClick,
  isCtaLoading,
  isCtaDisabled,
  ctaText,
  'data-testid': testId,
}: PricingPlanCardCtaButtonProps) {
  return (
    <Button
      variant={variant}
      size="md"
      className="h-auto min-h-9 w-full whitespace-normal py-2 text-center leading-5"
      onClick={onClick}
      disabled={isCtaLoading || isCtaDisabled}
      aria-busy={isCtaLoading}
      data-testid={testId}
    >
      {isCtaLoading ? <Loader2 className="size-4 animate-spin" aria-hidden /> : icon}
      {ctaText}
    </Button>
  );
}
